import { Builder, MAT } from '../engine/builder';
import { V3 } from '../engine/math';

// The blank stage for choosing and carving: a floor that curves up into a back wall with no seam, like a photo
// studio's sweep, so the gourds sit in nothing but their own pools of light. The floor is polished granite.

export const STAGE_LAMP: V3 = [0, 3.1, 1.5];

/** three spots on stands, left, middle and right, all on the gourds: each throws its own fairly sharp shadow */
export const STAGE_SPOTS: { at: V3; col: V3 }[] = [
  { at: [-2.6, 2.3, 1.9], col: [2.3, 2.05, 1.8] },
  { at: [0.15, 3.3, 2.6], col: [3.6, 3.4, 3.15] },
  { at: [2.7, 2.1, 1.6], col: [1.75, 1.85, 2.15] },
];

export function buildStage(): { v: Float32Array; i: Uint32Array } {
  const b = new Builder(), col: V3 = [0.06, 0.058, 0.057];
  // the profile from the front of the floor to the top of the wall: z, y and the normal there
  const prof: [number, number, number, number][] = [];
  for (let z = 4; z > -1.6; z -= 0.4) prof.push([z, 0, 0, 1]);
  const R = 1.4, z0 = -1.6;
  for (let k = 0; k <= 12; k++) {
    const a = (k / 12) * Math.PI / 2;
    prof.push([z0 - R * Math.sin(a), R * (1 - Math.cos(a)), Math.sin(a), Math.cos(a)]);
  }
  prof.push([z0 - R, 7, 1, 0]);
  const xs = [-8, -4, -2, -1, 0, 1, 2, 4, 8];
  const base = b.count;
  for (const [z, y, nz, ny] of prof) for (const x of xs) b.vert([x, y, z], [0, ny, nz], col, MAT.granite);
  const n = xs.length;
  for (let k = 0; k < prof.length - 1; k++) for (let j = 0; j < n - 1; j++) {
    const a = base + k * n + j, c = a + n;
    b.tri(a, a + 1, c + 1); b.tri(a, c + 1, c);
  }
  return b.data();
}
